import React, { ReactNode, useContext } from 'react';
import { StopProps } from './DetailsInfo.types';
import { Stack } from 'office-ui-fabric-react';
import { typeSafeObjectKeys } from './typings';
import { stopStrings } from './consts';
import { Styled } from './DetailsInfo.styles';
import { mapContext } from '../mapContext';
import { useMapHelpers } from '../../../../../hooks/useMapHelpers';
import { GeoJSON, LatLngTuple } from 'leaflet';

export const StopDetails: React.FC<StopProps> = ({ id }) => {
  const { mapElements, routes, setDetailsInfo, mapRef } = useContext(
    mapContext
  );
  const { centerMap } = useMapHelpers(mapRef);
  const stop = mapElements?.selectedStops.find((stop) => stop.id === id);

  if (!stop) return null;

  const relativeRoutes = mapElements?.initialRoutes.filter(({ stops }) =>
    stops.find((stop) => stop.id === id)
  );

  const fullInfoRoutes = relativeRoutes?.map((route) => {
    const r = routes.find(({ id }) => id === route.route_id);
    return {
      ...route,
      name: r?.short_name || '',
    };
  });

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      {typeSafeObjectKeys(stopStrings).map((key) => {
        let data: ReactNode = null;
        switch (key) {
          case 'routes':
            data = (
              <Styled.ListWrapper>
                {fullInfoRoutes?.map(({ name, trajectory }) => {
                  const latlngs: LatLngTuple[] = trajectory
                    .slice(11, -1)
                    .split(',')
                    .map((route) =>
                      route.split(' ').map((route) => parseFloat(route))
                    )
                    .map((routeCoords) => [routeCoords[1], routeCoords[0]]);

                  console.log(latlngs);

                  const onClick = () => {
                    centerMap(latlngs);
                    setDetailsInfo(null);
                  };
                  return (
                    <button onClick={onClick} key={name}>
                      {name}
                    </button>
                  );
                })}
              </Styled.ListWrapper>
            );
            break;
          case 'name':
            data = stop.name;
            break;
        }
        return (
          <Styled.InfoRow key={key}>
            <Styled.InfoRowTitle>{stopStrings[key]}</Styled.InfoRowTitle>
            <Styled.InfoRowData>{data || ' - '}</Styled.InfoRowData>
          </Styled.InfoRow>
        );
      })}
    </Stack>
  );
};
